import SimpleBar from 'simplebar';

export default class TableScroll {
	constructor(table) {
		this.table = table;
		this.tableWrapper = this.table.parentElement;
		this.titleContainer = this.table.parentElement.querySelectorAll('[data-table-title]');
		this.tableWrapperWidth = 0;
		this.tableHead = this.table.querySelectorAll('thead');
		this.tableBodyChildren = this.table.querySelector('tbody').children;
		this.tableWidth = 0;
		this.hasSubHeading = false;
		this.loadSimpleBar();
		this.checkTableWidth();
		this.setTableTitleWidth();
		this.tableFadeHeight();
		this.dragToScroll();
		this.displayTable();

		window.addEventListener('resize', () => {
			this.checkTableWidth();
			this.setTableTitleWidth();
			this.tableFadeHeight();
		});
	}

	loadSimpleBar() {
		new SimpleBar(this.table); // eslint-disable-line
	}

	displayTable() {
		this.table.closest('[data-em-table]').classList.add('loaded');
	}

	/**
	 * Checks Table Body first to determine if first row is a sub-heading.
	 */
	checkSubHeading() {
		try {
			if (typeof this.tableBodyChildren !== 'undefined') {
				const hasSubHeading = typeof Object.values(Object.values(this.tableBodyChildren)[0].children)[0].dataset.colorTheme !== 'undefined';
				if (hasSubHeading) {
					this.hasSubHeading = true;
				}
			}
		} catch (error) {
			console.warn(error);
		}
	}

	checkTableWidth() {
		const { tableWrapper } = this;
		this.tableWrapperWidth = tableWrapper.offsetWidth;
		this.tableWidth = tableWrapper.querySelector('table').offsetWidth;
	}

	dragToScroll() {
		const { table } = this;
		const el = table.querySelector('.simplebar-content-wrapper');
		let isDown = false;
		let startX;
		let scrollLeft;

		el.classList.add('drag-to-scroll');

		el.addEventListener('mousedown', (e) => {
			isDown = true;
			el.classList.add('active');
			startX = e.pageX - el.offsetLeft;
            scrollLeft = el.scrollLeft; // eslint-disable-line
		});
		el.addEventListener('mouseleave', () => {
			isDown = false;
			el.classList.remove('active');
		});
		el.addEventListener('mouseup', () => {
			isDown = false;
			el.classList.remove('active');
		});
		el.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - el.offsetLeft;
			const walk = (x - startX) * 3; // scroll-fast
			el.scrollLeft = scrollLeft - walk;
		});
	}

	tableFadeHeight() {
		const { table, tableWrapperWidth, tableWidth } = this;
		const parent = table.parentElement;
		const headerFade = parent.querySelector('.header-fade');
		const tableFade = parent.querySelector('.table-fade');

		if (tableWidth > tableWrapperWidth) {
			let titleHeight = 0;
			if (this.titleContainer.length) {
				titleHeight = this.titleContainer[0].clientHeight;
			}

			// Check for subheading in table and apply height.
			this.checkSubHeading();
			let subHeaderHeight = 0;
			if (this.hasSubHeading && this.tableBodyChildren.length) {
				subHeaderHeight = this.tableBodyChildren[0].clientHeight;
			}

			const containerHeight = parent.querySelector('[data-table-container]').clientHeight;
			const tableHeaderHeight = parent.querySelector('table thead').clientHeight;
			const headerHeightValue = `${titleHeight + tableHeaderHeight + subHeaderHeight}px`;

			headerFade.style.height = headerHeightValue;
			tableFade.style.height = `${containerHeight - titleHeight - tableHeaderHeight - subHeaderHeight}px`;
			tableFade.style.top = headerHeightValue;
		} else {
			headerFade.style.height = 0;
			tableFade.style.height = 0;
		}
	}

	setTableTitleWidth() {
		if (this.titleContainer.length) {
			const { tableWidth, tableWrapper, tableHead } = this;
			const { titleCount } = tableWrapper.dataset;
			const titles = Object.values(this.titleContainer[0].children);

			/**
			 * Get Width of Table Headers based on theme grouping for Titles.
			 */
			let theadChildren = [];
			const theadDimensions = [];
			if (tableHead.length && titleCount > 1) {
				theadChildren = Object.values(tableHead[0].querySelector('tr').children);
				if (theadChildren.length) {
					let columnSetIterator = 1;
					let width = 0;
					const theadChildrenCount = theadChildren.length;
					theadChildren.forEach((child, key) => {
						const iterator = parseInt(child.dataset.themeIterator);
						if (columnSetIterator === iterator) {
							width += child.offsetWidth;

							// If last loop through append width results to theadDimensions.
							if ((key + 1) === theadChildrenCount) {
								theadDimensions.push(width);
								width = 0;
							}
						} else {
							columnSetIterator = iterator > columnSetIterator ? iterator : columnSetIterator;
							theadDimensions.push(width);
							width = child.offsetWidth;
						}
					});
				}
			}

			// Set Title Container Width.
			if (titleCount > 1) {
				this.titleContainer[0].style.width = `${tableWidth}px`;
			}

			// Set Individual Title Widths.
			titles.forEach((title, key) => {
				if (titleCount > 1 && theadDimensions.length) {
					title.style.width = `${theadDimensions[key]}px`;
				} else {
					title.style.width = `${tableWidth}px`;
				}
			});
		}
	}
}
